import './form-util-age-bracket.scss';

import { UtilAgeBracketFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";
import { useParams } from 'react-router-dom';

type InputFormSchema = UtilAgeBracketFormSchema;
export function FormUtilAgeBracket() {
  const { control, setValue } = useFormContext<UtilAgeBracketFormSchema>();
  const { transportTypeId, hotelId } = useParams();
  setValue('type', transportTypeId || hotelId || "")


  return (
    <div id="FormUtilAgeBracket" className="util-age-bracket">
      {/* <InputControl<InputFormSchema>
        control={control}
        name="type"
        label="Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter type"
      /> */}
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="price"
        label="Price"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter price"
      />
    </div>
  );
}

export default FormUtilAgeBracket;